export default "__VITE_ASSET__dc2f802c__"